import React from 'react';
import { Stack, Chip } from '@mui/material';

type Site = { id: number; name: string };
type Props = {
  sites: Site[];
  onDelete: (id: number) => void;
};

export function SelectedSitesChips({ sites, onDelete }: Props) {
  return (
    <Stack direction='row' spacing={1} sx={{ mt: 1, mb: 2 }}>
      {sites.map((site) => (
        <Chip key={site.id} label={site.name} color='secondary' onDelete={() => onDelete(site.id)} />
      ))}
    </Stack>
  );
}
